import { render, staticRenderFns } from "./session-channel.vue?vue&type=template&id=99590bd6&"
import script from "./session-channel.vue?vue&type=script&lang=js&"
export * from "./session-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports